const RoutingGuideTypes = {
  ADD_ROUTING_GUIDE_CARRIER_PROGRESS: 'ROUTING_GUIDE_TYPE.ADD_ROUTING_GUIDE_CARRIER_PROGRESS',

  ADD_ROUTING_GUIDE_COLLABORATORS_PROGRESS: 'ROUTING_GUIDE_TYPE.ADD_ROUTING_GUIDE_COLLABORATORS_PROGRESS',

  ADD_ROUTING_GUIDE_HEADER: 'ROUTING_GUIDE_TYPE.ADD_ROUTING_GUIDE_HEADER',

  CLIENT_CODE_DATA: 'ROUTING_GUIDE_TYPE.CLIENT_CODE_DATA',
  CREATE_ROUTING_GUIDE_CLEAR: 'ROUTING_GUIDE_TYPE.CREATE_ROUTING_GUIDE_CLEAR',

  CREATE_ROUTING_GUIDE_PROGRESS: 'ROUTING_GUIDE_TYPE.CREATE_ROUTING_GUIDE_PROGRESS',
  CREATE_ROUTING_GUIDE_SUCCESS: 'ROUTING_GUIDE_TYPE.CREATE_ROUTING_GUIDE_SUCCESS',
  CREATE_ROUTING_GUIDE_USER_CLEAR: 'ROUTING_GUIDE_TYPE.CREATE_ROUTING_GUIDE_USER_CLEAR',

  CREATE_ROUTING_GUIDE_USER_PROGRESS: 'ROUTING_GUIDE_TYPE.CREATE_ROUTING_GUIDE_USER_PROGRESS',
  CREATE_ROUTING_GUIDE_USER_SUCCESS: 'ROUTING_GUIDE_TYPE.CREATE_ROUTING_GUIDE_USER_SUCCESS',

  DELETE_NXP_USER: 'ROUTING_GUIDE_TYPE.DELETE_NXP_USER',
  DELETE_NXP_USER_FAIL: 'ROUTING_GUIDE_TYPE.DELETE_NXP_USER_FAIL',
  DELETE_NXP_USER_SUCCESS: 'ROUTING_GUIDE_TYPE.DELETE_NXP_USER_SUCCESS',

  DELETE_ROUTING_GUIDE_CARRIER_PROGRESS: 'ROUTING_GUIDE_TYPE.DELETE_ROUTING_GUIDE_CARRIER_PROGRESS',
  DELETE_ROUTING_GUIDE_COLLABORATOR_PROGRESS: 'ROUTING_GUIDE_TYPE.DELETE_ROUTING_GUIDE_COLLABORATOR_PROGRESS',
  DELETE_ROUTING_GUIDES_ERROR: 'ROUTING_GUIDE_TYPE.DELETE_ROUTING_GUIDES_ERROR',

  DELETE_ROUTING_GUIDES_PROGRESS: 'ROUTING_GUIDE_TYPE.DELETE_ROUTING_GUIDES_PROGRESS',
  DELETE_ROUTING_GUIDES_SUCCESS: 'ROUTING_GUIDE_TYPE.DELETE_ROUTING_GUIDES_SUCCESS',
  EDIT_CARRIER_ROUTING_GUIDE_ERROR: 'ROUTING_GUIDE_TYPE.EDIT_CARRIER_ROUTING_GUIDE_ERROR',
  EDIT_CARRIER_ROUTING_GUIDE_PROGRESS: 'ROUTING_GUIDE_TYPE.EDIT_CARRIER_ROUTING_GUIDE_PROGRESS',
  EDIT_CARRIER_ROUTING_GUIDE_SUCCESS: 'ROUTING_GUIDE_TYPE.EDIT_CARRIER_ROUTING_GUIDE_SUCCESS',
  EDIT_COLLABORATORS_ROUTING_GUIDE_PROGRESS: 'ROUTING_GUIDE_TYPE.EDIT_COLLABORATORS_ROUTING_GUIDE_PROGRESS',
  GET_ALL_USERS_NAME_PROGRESS: 'ROUTING_GUIDE_TYPE.GET_ALL_USERS_NAME_PROGRESS',
  GET_ALL_USERS_NAME_SUCCESS: 'ROUTING_GUIDE_TYPE.GET_ALL_USERS_NAME_SUCCESS',
  GET_CARRIERS_ROUTING_GUIDE_ERROR: 'ROUTING_GUIDE_TYPE.GET_CARRIERS_ROUTING_GUIDE_ERROR',

  GET_CARRIERS_ROUTING_GUIDE_PROGRESS: 'ROUTING_GUIDE_TYPE.GET_CARRIERS_ROUTING_GUIDE_PROGRESS',
  GET_CARRIERS_ROUTING_GUIDE_SUCCESS: 'ROUTING_GUIDE_TYPE.GET_CARRIERS_ROUTING_GUIDE_SUCCESS',
  GET_COLLABORATORS_ROUTING_GUIDE_PROGRESS: 'ROUTING_GUIDE_TYPE.GET_COLLABORATORS_ROUTING_GUIDE_PROGRESS',
  GET_COLLABORATORS_ROUTING_GUIDE_SUCCESS: 'ROUTING_GUIDE_TYPE.GET_COLLABORATORS_ROUTING_GUIDE_SUCCESS',

  GET_CONTENT_NXP_ROUTING_GUIDE: 'ROUTING_GUIDE_TYPE.GET_CONTENT_NXP_ROUTING_GUIDE',
  GET_CONTENT_NXP_ROUTING_GUIDE_ERROR: 'ROUTING_GUIDE_TYPE.GET_CONTENT_NXP_ROUTING_GUIDE_ERROR',
  GET_CONTENT_NXP_ROUTING_GUIDE_SUCCESS: 'ROUTING_GUIDE_TYPE.GET_CONTENT_NXP_ROUTING_GUIDE_SUCCESS',

  GET_FILTERED_GUIDE_LIST: 'ROUTING_GUIDE_TYPE.GET_FILTERED_GUIDE_LIST',

  GET_NXP_USER_SEARCH_CLEAR_DATA: 'ROUTING_GUIDE_TYPE.GET_NXP_USER_SEARCH_CLEAR_DATA',
  GET_NXP_USER_SEARCH_FAIL: 'ROUTING_GUIDE_TYPE.GET_NXP_USER_SEARCH_FAIL',

  GET_NXP_USER_SEARCH_INPROGRESS: 'ROUTING_GUIDE_TYPE.GET_NXP_USER_SEARCH_INPROGRESS',
  GET_NXP_USER_SEARCH_RESET_REQUEST: 'ROUTING_GUIDE_TYPE.GET_NXP_USER_SEARCH_RESET_REQUEST',
  GET_NXP_USER_SEARCH_SUCCESS: 'ROUTING_GUIDE_TYPE.GET_NXP_USER_SEARCH_SUCCESS',

  GET_NXP_USER_SELECTED_RECORD: 'ROUTING_GUIDE_TYPE.GET_NXP_USER_SELECTED_RECORD',
  GET_ROUTING_GUIDE_DATA_RESET: 'RoutingGuideTypes.GET_ROUTING_GUIDE_DATA_RESET',
  GET_ROUTING_GUIDE_LIST: 'ROUTING_GUIDE_TYPE.GET_ROUTING_GUIDE_LIST',
  GET_ROUTING_GUIDE_LIST_CLEAR_REQ: 'ROUTING_GUIDE_TYPE.GET_ROUTING_GUIDE_LIST_CLEAR_REQ',
  GET_ROUTING_GUIDE_SUCCESS: 'ROUTING_GUIDE_TYPE.GET_ROUTING_GUIDE_SUCCESS',

  NPX_USER_TYPES_DATA: 'ROUTING_GUIDE_TYPE.NPX_USER_TYPES_DATA',

  RESET_ROUTING_GUIDE_SEARCH_PARAMS: 'ROUTING_GUIDE_TYPE.RESET_ROUTING_GUIDE_SEARCH_PARAMS',

  SET_ROUTING_GUIDE_SEARCH_PARAMS: 'ROUTING_GUIDE_TYPE.SET_ROUTING_GUIDE_SEARCH_PARAMS',

  SET_ROUTING_SPOT_FILTERED_DATA: 'SET_ROUTING_SPOT_FILTERED_DATA',

  SET_SELECTED_ROUTING_GUIDE: 'ROUTING_GUIDE_TYPE.SET_SELECTED_ROUTING_GUIDE',

  SET_TRANSPORT_DATA: 'ROUTING_GUIDE_TYPE.SET_TRANSPORT_DATA',

  UPDATE_CONTENT_NXP_ROUTING_GUIDE: 'ROUTING_GUIDE_TYPE.UPDATE_CONTENT_NXP_ROUTING_GUIDE',
  UPDATE_CONTENT_NXP_ROUTING_GUIDE_ERROR: 'ROUTING_GUIDE_TYPE.UPDATE_CONTENT_NXP_ROUTING_GUIDE_ERROR',
  UPDATE_CONTENT_NXP_ROUTING_GUIDE_SUCCESS: 'ROUTING_GUIDE_TYPE.UPDATE_CONTENT_NXP_ROUTING_GUIDE_SUCCESS',
};

// biome-ignore lint/style/noDefaultExport: TODO: fix
export default RoutingGuideTypes;
